var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    "data-name": "user, account, people, man"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.737 16.181a1 1 0 1 0-1.406 1.422A8.938 8.938 0 0 1 25 24c0 1.223-3.506 3-9 3s-9-1.778-9-3.002a8.938 8.938 0 0 1 2.635-6.363 1 1 0 1 0-1.414-1.414A10.927 10.927 0 0 0 5 24c0 3.248 5.667 5 11 5s11-1.752 11-5a10.92 10.92 0 0 0-3.263-7.819z",
    fill: "#999999",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 17a7 7 0 1 0-7-7 7.008 7.008 0 0 0 7 7zm0-12a5 5 0 1 1-5 5 5.006 5.006 0 0 1 5-5z",
    fill: "#999999",
    opacity: 1,
    "data-original": "#000000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.97bedde2f70230f6c275c64e694ecb4d.svg";
export { ForwardRef as ReactComponent };